import { render } from "./ManageClaims.vue?vue&type=template&id=1f436fdc"
import script from "./ManageClaims.vue?vue&type=script&lang=js"
export * from "./ManageClaims.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__